// ModalHint.jsx

import React from 'react';

// CSS
import './ModalHint.css';

/**
 * ModalHint
 * 
 * A simple hint component for modals.
 *  
 *
 * @param {string} hint - The text to display inside the hint.
 * 
 * @returns {ReactNode} - ModalHint.
 */
const ModalHint = React.memo(({ hint }) => {

    // ----- CONTEXT ----- //

    if (!hint || hint.trim() === '') return null;

    // ----- RENDER ----- //

    return (

        <div
          className="modal-hint-container"
        >
            {hint}
        </div>

    );

});

// Dev Tools
ModalHint.displayName = 'ModalHint';

export default ModalHint;
